import { render, staticRenderFns } from "./rewardSerialPackEdit.vue?vue&type=template&id=bd2ca5bc&scoped=true&"
import script from "./rewardSerialPackEdit.vue?vue&type=script&lang=js&"
export * from "./rewardSerialPackEdit.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bd2ca5bc",
  null
  
)

export default component.exports